import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Coffee, Heart } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="relative z-10 min-h-screen bg-[#F9F8F6] flex flex-col">
      <Header />
      <section className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-lg text-center">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#9F583F]/12 text-[#9F583F] mb-6">
            <Coffee size={30} strokeWidth={1.6} />
          </span>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#1C1917]">
            Grazie di cuore!
          </h1>
          <p className="font-body text-lg text-[#57534E] mt-5 leading-relaxed">
            Il tuo caffè scalda davvero il Cassetto delle Giraffe. Gesti piccoli come
            il tuo mi permettono di continuare a scrivere, raccontare e incuriosire.
            A presto tra queste pagine! <Heart size={16} className="inline text-[#9F583F]" />
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 bg-[#1C1917] hover:bg-[#9F583F] text-white label-ui px-7 py-4 transition-colors"
          >
            Torna agli articoli
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
